import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';
import Button from '@/components/Button';
import { HideScrollbar } from '@/components/styles';

export const Component = styled.div<{ isStaff?: boolean }>`
  position: relative;
  padding: 32px 40px 20px;
  width: calc(100vw - 20px);
  max-width: 515px;
  min-height: 50px;
  border-radius: 10px;
  background: ${(props) => props.theme.white};

  ${HideScrollbar}

  ${media.tablet(css`
    max-height: none;
    overflow-y: initial;
  `)}

  ${media.mobile(css`
    padding: 20px 10px;
    max-width: none;
  `)};

  ${({ isStaff }) =>
    isStaff &&
    css`
      max-width: 1132px;
    `}
`;

export const Title = styled.p`
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: ${(props) => props.theme.black200};
`;

export const Table = styled.div`
  margin-top: 20px;
`;

export const Row = styled.div<{
  isHeaderRow?: boolean;
  withBackground?: boolean;
}>`
  display: flex;
  padding: 4.5px 16px;

  ${media.mobile(css`
    padding: 7px 25px;
  `)}

  ${({ isHeaderRow }) =>
    isHeaderRow &&
    css`
      padding: 6px 16px;

      ${media.mobile(css`
        padding: 8px 25px;
      `)}
    `}

  ${({ withBackground }) =>
    withBackground &&
    css`
      background: ${(props) => props.theme.gray100};
    `}
`;

export const RowItem = styled.div<{ colCount: number }>`
  width: calc(100% / ${({ colCount }) => colCount});

  &:not(:first-child) {
    text-align: right;
  }
`;

export const RowTitle = styled.p<{
  isHeaderTitle?: boolean;
  isYearTitle?: boolean;
  isOpacity?: boolean;
}>`
  font-size: 14px;
  line-height: 28px;
  color: ${(props) => props.theme.black100};

  &:first-letter {
    text-transform: capitalize;
  }

  ${media.mobile(css`
    line-height: 16px;
  `)}

  ${({ isHeaderTitle }) =>
    isHeaderTitle &&
    css`
      font-size: 16px;
      line-height: 28px;
      color: ${(props) => props.theme.black200};

      ${media.mobile(css`
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
      `)}
    `}

  ${({ isYearTitle }) =>
    isYearTitle &&
    css`
      font-weight: 500;
      color: ${(props) => props.theme.black200_alpha40};
    `}

  ${({ isOpacity }) =>
    isOpacity &&
    css`
      opacity: 0.56;
    `}
`;

export const StyledButton = styled(Button)`
  margin-top: 30px;
`;
